module.exports = __webpack_public_path__ + "img/double.11dc3cd2.png";